// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"d9f2c4b8","787":"30e7697e","936":"01f7226f"}[chunkId] + ".chunk.js";
};